import { defineMessages } from 'react-intl';

export default defineMessages({
    CancelModalHeader: {
        id: 'cep.components.sgRenewal.CancelModalHeader',
        defaultMessage: 'Are you sure you want to leave this page?'
    },
    CancelModalMessage: {
        id: 'cep.components.sgRenewal.CancelModalMessage',
        defaultMessage: 'Information will not be saved if you choose to leave'
    },
    CancelModalCancelBtnLabel: {
        id: 'cep.components.sgRenewal.CancelModalCancelBtnLabel',
        defaultMessage: 'I want to leave'
    },
    CancelModalConfirmBtnLabel: {
        id: 'cep.components.sgRenewal.CancelModalConfirmBtnLabel',
        defaultMessage: 'I want to stay'
    }
});
